import React, { useState, useEffect } from 'react';
import { pick, get } from 'lodash';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Card, Wizard, Modal, Icon, Loader } from 'components';
import { IndividualBasicInformationForm, CorpoCoopOtherInformationForm, ExistingFranchiseForm, 
  AuthorizedDriversForm, RequiredDocuments, ApplicationPreview, RepresentativeForm, ReuploadRequiredDocuments } from 'control-components';
import { useAction, useSelect, useModal, useForm, useFormValidator } from 'hooks';
import { options as individualBasicInformationFormOptions  } from 'control-components/IndividualBasicInformationForm';
import { options as corpoCoopOtherInformationFormOptions } from 'control-components/CorpoCoopOtherInformationForm';
import { options as existingFranchiseOptions } from 'control-components/ExistingFranchiseForm';
import { options as authorizedDriversFormOptions } from 'control-components/AuthorizedDriversForm';
import { options as requiredDocumentsOptions } from 'control-components/RequiredDocuments';
import { options as representativeOptions } from 'control-components/RepresentativeForm';
import {  toast } from 'react-toastify';
import ContainerTransactionItem from '../transaction-history/ContainerTransactionItem';

const rules = {
  ...existingFranchiseOptions.rules,
  ...authorizedDriversFormOptions.rules,
  ...requiredDocumentsOptions.rules,
  //...representativeOptions.rules,
}

const initFormData = {
  ...existingFranchiseOptions.initialFormData,
  ...authorizedDriversFormOptions.initialFormData,
  ...requiredDocumentsOptions.initialFormData,
  ...representativeOptions.initialFormData,
  
}

const ApplicationForm = ({ initialValue, method }) => {
  const params = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const history = useHistory()
  const [selected, setSelected] = useState(0)
  const [isOpenSuccesModal, onOpenSuccessModal, onCloseSuccessModal] = useModal()
  const create = useAction('application.create')
  const createOthers = useAction('application.createOthers')
  const resubmit = useAction('application.update')
  const updating = useSelect('loading.isLoading', { type: 'application.update' })
  const creating = useSelect('loading.isLoading', { type: 'application.create' })
  // const selectedOwnershipTyped = useSelect('ownershipType.selected')
  // const viewOwnershipTyped = useAction('ownershipType.show')
  const branchGetList = useAction('branch.getList')
  const branchSelected = useSelect('branch.selected', { id: process.env.REACT_APP_DEFAULT_BRANCH })
  // const selectedTransactionType = useSelect('transactionType.selected')
  // const viewTransactionType = useAction('transactionType.show')
  const profile = useSelect('auth.profile');
  const user = useSelect('auth.user');
  
  const [value, { onChange,  onChangeNumber, onSetForm }] = useForm(initialValue || {})
  const { response, onSetObjectRules } = useFormValidator(value, {})
  const appTransaction = JSON.parse(localStorage.getItem('app_transaction')) || {}
  

  const getSelected = useAction('payment.view')
  const selectedPayment = useSelect('payment.selected', { id: get(appTransaction, 'payment_id') })
  const selectedServiceType = useSelect('serviceType.selected', { id: value.service_type_id })
  const viewing = useSelect('loading.isLoading', { type: 'payment.view' })

  useEffect(() => {
    if(get(appTransaction, 'payment_id'))
      getSelected(get(appTransaction, 'payment_id'))
      // eslint-disable-next-line
  }, [get(appTransaction, 'payment_id')])


  useEffect(() => {
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
    
    if(+get(appTransaction, 'transaction_kind') === 1)
      setSelected(localStorage.getItem('app_tab') || 0)

    if(+get(appTransaction, 'transaction_kind') === 2)
      setSelected(0)
    return () => {
      localStorage.removeItem('app_tab')
      localStorage.removeItem('app_data')
      localStorage.removeItem('app_transaction')
    }
    // eslint-disable-next-line
  }, [])

  const clearLocalStorage = () => {
    localStorage.removeItem('app_tab')
    localStorage.removeItem('app_data')
    localStorage.removeItem('app_transaction')
  }

  useEffect(() => {
    if(+get(appTransaction, 'transaction_kind') === 1 && +get(appTransaction, 'ownership_type_id') === 1){
    
      const formDataForNewType = {
        ...individualBasicInformationFormOptions.initialFormData,
        ...initFormData,
        ...get(pick(profile, 'attributes'), 'attributes'),
        ...get(pick(user, 'attributes'), 'attributes'),
        contact_number: get(profile, 'attributes.mobile_number'),
        signature_url: '',
        representative_signature_url: ''
      }
      onSetForm({
        ...formDataForNewType,
        ...JSON.parse(localStorage.getItem('app_data')) 
      })

      onSetObjectRules({
        ...individualBasicInformationFormOptions.rules,
        ...rules
      })
    }

    if(+get(appTransaction, 'transaction_kind') === 1 && [2,3,4].indexOf(+get(appTransaction, 'ownership_type_id')) > -1){

      const formDatForOtherOwnerType = {
        ...corpoCoopOtherInformationFormOptions.initialFormData,
        ...representativeOptions.initialFormData,
        ...initFormData,
        representative_signature_url: ''
      }

      onSetForm({
        ...formDatForOtherOwnerType,
        ...JSON.parse(localStorage.getItem('app_data')) 
      })

      onSetObjectRules({
        ...corpoCoopOtherInformationFormOptions.rules,
        ...representativeOptions.rules,
        ...rules,
        representative_signature_url: 'required'
      })
    }

    if(+get(appTransaction, 'transaction_kind') === 2){
      onSetForm({
        
        ...requiredDocumentsOptions.initialFormData,
        // ...JSON.parse(localStorage.getItem('app_data')) 
      })

      onSetObjectRules({
        ...requiredDocumentsOptions.rules
      })
    }
    
    setIsLoading(false)
    // eslint-disable-next-line
  }, [+get(appTransaction, 'transaction_kind'), +get(appTransaction, 'ownership_type_id'), user])

  
  useEffect(() => {
    branchGetList()
    // eslint-disable-next-line
  }, [])

  const handleNext = data => e => {
    e.preventDefault()
    setSelected(+selected + 1)
    const appData = {
      ...value,
      ...data
    }
    onSetForm(appData)
    localStorage.setItem('app_tab', +selected + 1)
    localStorage.setItem('app_data', JSON.stringify(appData))
  }

  const handlePrevious = data => e => {
    e.preventDefault()
    setSelected(selected - 1)

    const appData = {
      ...value,
      ...data
    }

    onSetForm(appData)
    localStorage.setItem('app_tab', +selected - 1)
    localStorage.setItem('app_data', JSON.stringify(appData))
  }

  const onSetFormWithLocalStorage = (data) => {

    const appData = {
      ...value,
      ...data
    }

    onSetForm(appData)
    localStorage.setItem('app_data', JSON.stringify(appData))
  }

  const handleSubmit = e => {
    e.preventDefault()

    // if(!response.is_passed) return false

    if(!appTransaction){
      toast.danger('Data broken, please try again')
      return history.push('/')
    }
      
    if(get(appTransaction, 'transaction_kind') === 1){
      if(method === 'update'){
        return resubmit(
          params.id, {
          ...value,
          branch_id: get(branchSelected, 'id'),
          ownership_type_id: get(appTransaction, 'ownership_type_id')
        }, () => {
          const appId = params.id
          clearLocalStorage()
          onOpenSuccessModal()
          if(get(selectedServiceType, 'attributes.name') === 'TNVS'){
            onOpenSuccessModal()
            history.push(`/application/${appId}/appointment`)
            history.go(0)
          } else {
            return history.push('/')
          }
        })
      }
      return create({
        ...value,
        branch_id: get(branchSelected, 'id'),
        ownership_type_id: get(appTransaction, 'ownership_type_id')
      }, (data) => {
        const appId = Object.values(data)[0].relationships.payment.data.id
        clearLocalStorage()
        onOpenSuccessModal()
        if(get(selectedServiceType, 'attributes.name') === 'TNVS'){
          onOpenSuccessModal()
          return history.push(`/application/${appId}/appointment`)
        } else {
          return history.push('/')
        }
      })
    }

    if(get(appTransaction, 'transaction_kind') === 2)
      return createOthers({
        application_requirements: JSON.stringify({
          ...value
        }),
        payment_id: get(appTransaction, 'payment_id')
      }, () => {
        clearLocalStorage()
        onOpenSuccessModal()
      })

    toast.danger('Data broken, please try again')
    return history.push('/') 
  }

  const handleOk = e => {
    e.preventDefault()
    onCloseSuccessModal()
    setTimeout(() => {
      history.push('/')
    }, 100)
  }

  return (
    <>
      <Card>
        <Card.Header>
          <b className="title font-medium">
            {+get(appTransaction, 'transaction_kind') === 2 ? 'Extention of Validity / Others' : 'Application Form '}
            {method === 'update' && ' - RESUBMIT'}
          </b>
        </Card.Header>
        <Card.Body>
          {!viewing && +get(appTransaction, 'transaction_kind') === 2 && selectedPayment &&
            <>
              <b className="text-success font-medium text-sm">Current CPC</b>
              <ContainerTransactionItem data={selectedPayment}/>
            </>}
            {!viewing && method === 'update' && selectedPayment &&
            <>
              <b className="text-success font-medium text-sm">Current CPC</b>
              <ContainerTransactionItem data={selectedPayment}/>
            </>}
          {!viewing && +get(appTransaction, 'transaction_kind') === 2 &&   selectedPayment &&
            <>
              <b className="text-success font-medium text-sm">Application to apply</b>
              <ul className="flex flex-col space-y-2 p-2 border-2 border-gray-400 mt-2 rounded">
                {get(appTransaction, 'transaction_type_multiple', []).length > 0 && get(appTransaction, 'transaction_type_multiple', []).map(x => {
                  return (
                    <li key={`transactionType${x.value}`} className="flex items-center space-x-3 text-sm">
                      <p>{x.label}</p>
                    </li>
                  )
                })}
              </ul>
            </>
          }
          {viewing && <Loader.Table />}
          {!isLoading &&
          <form onSubmit={handleSubmit}>
            <Wizard selected={+selected}>
              {+get(appTransaction, 'transaction_kind') === 1 && +get(appTransaction, 'ownership_type_id') === 1 &&
              <IndividualBasicInformationForm 
                description="Basic Information"
                name="basic_info"
                onNext={handleNext}
                initialValue={pick(value, Object.keys(individualBasicInformationFormOptions.initialFormData))}
              />}
              {+get(appTransaction, 'transaction_kind') === 1 && [2,3,4].indexOf(+get(appTransaction, 'ownership_type_id')) > -1 &&
              <CorpoCoopOtherInformationForm 
                description="Corporation/Cooperative/Other Information"
                name="corpo_info"
                onNext={handleNext}
                initialValue={pick(value, Object.keys(corpoCoopOtherInformationFormOptions.initialFormData))}
              />}
              {+get(appTransaction, 'transaction_kind') === 1 && 
              <RepresentativeForm 
                description="Representative"
                name="representative_info"
                onPrevious={handlePrevious}
                onNext={handleNext}
                initialValue={pick(value, Object.keys(representativeOptions.initialFormData))}
              />}
              {+get(appTransaction, 'transaction_kind') === 1 && 
              <ExistingFranchiseForm 
                description="Unit Information"
                id={params.id}
                method={method}
                onChangeNumber={onChangeNumber}
                onNext={handleNext}
                onPrevious={handlePrevious}
                initialValue={pick(value, Object.keys(existingFranchiseOptions.initialFormData))}
              />}
              {+get(appTransaction, 'transaction_kind') === 1 &&
              <AuthorizedDriversForm 
                description="Authorized Drivers"
                onNext={handleNext}
                onPrevious={handlePrevious}
                initialValue={pick(value, Object.keys(authorizedDriversFormOptions.initialFormData))}
              />}
              {!method &&
              <RequiredDocuments 
                description="Required Documents"
                onNext={handleNext}
                onPrevious={handlePrevious}
                initialValue={pick(value, Object.keys(requiredDocumentsOptions.initialFormData))}
                isPassed={response.is_passed}
                onSetFormWithLocalStorage={onSetFormWithLocalStorage}
              />}
              {method === 'update' &&
              <ReuploadRequiredDocuments 
                description="Required Documents"
                onNext={handleNext}
                onPrevious={handlePrevious}
                initialValue={pick(value, Object.keys(requiredDocumentsOptions.initialFormData))}
                isPassed={response.is_passed}
                onSetFormWithLocalStorage={onSetFormWithLocalStorage}
              />}
              {+get(appTransaction, 'transaction_kind') === 1 &&
              <ApplicationPreview 
                isLoading={creating || updating}
                description="Preview"
                onChange={onChange}
                value={value}
                onPrevious={handlePrevious}
                onNext={handleNext}
                isPassed={response.is_passed}
                />}
            </Wizard>
          </form>}
        </Card.Body>
      </Card>
      <Modal isOpen={isOpenSuccesModal} >
        <div className="flex h-32">
          <div className="m-auto flex flex-col items-center space-y-10">
            <Icon.Check className="!w-20 !h-20"/>
            <p className="text-success">You application has been submitted and its for assessment!</p>
          </div>
        </div>
        <div className="flex justify-end mt-10">
          <Link onClick={handleOk} to="/" className="text-info">Ok</Link>
        </div>
      </Modal>
    </>
  )
}

export default ApplicationForm